import Cookies from 'js-cookie'
import config from '@/config'

const { tokenKey } = config

export function getToken () {
  if (Cookies.get(tokenKey)) {
    return Cookies.get(tokenKey)
  } else {
    return 'user'
  }
}

export function setToken (token) {
  return Cookies.set(tokenKey, token)
}

export function removeToken () {
  return Cookies.remove(tokenKey)
}
